import { get } from "lodash";
import { AssessmentResultRecordType } from "../types";

export default function getAssessmentCoursePasscode(
  assessment: AssessmentResultRecordType
) {
  return get(assessment, ["student", "passcode"]);
}
